import { render } from "./UkzCard.vue?vue&type=template&id=ed24dd0e"
import script from "./UkzCard.vue?vue&type=script&lang=js"
export * from "./UkzCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dharmik/www/pfizer-invoicing-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__